// frontend/src/actions/deliveryStaffActions.js
import {
  loginRequest,
  loginSuccess,
  loginFail,
  logout,
  clearError
} from '../slices/deliveryStaffSlice';
import axios from 'axios';

export const loginDeliveryStaff = (loginId, password) => async (dispatch) => {
  try {
      dispatch(loginRequest());
      const { data } = await axios.post('/api/v1/delivery/login', { loginId, password }, {
          withCredentials: true
      });
     
      if (data.success) {
          const deliveryStaffData = {
              deliveryStaff: data.user,
              token: data.token
          };
         
          localStorage.setItem('deliveryStaffInfo', JSON.stringify(deliveryStaffData));
          dispatch(loginSuccess(deliveryStaffData)); // Pass the entire data object
          return true;
      }
     
      dispatch(loginFail('Login failed'));
      return false;
  } catch (error) {
      dispatch(loginFail(error.response?.data?.message || 'Login failed'));
      return false;
  }
};

export const logoutDeliveryStaff = () => async (dispatch) => {
  try {
    await axios.get('/api/v1/delivery/logout', { withCredentials: true });
    localStorage.removeItem('deliveryStaffInfo');
    dispatch(logout());
    
    // Add window.location.href to force a full page reload and redirect
    window.location.href = '/delivery/login';
    return true;
  } catch (error) {
    console.error('Logout error:', error);
    // Even if the API call fails, still clear local storage and state
    localStorage.removeItem('deliveryStaffInfo');
    dispatch(logout());
    window.location.href = '/delivery/login';
    return false;
  }
};

export const getDeliveryProfile = () => async (dispatch) => {
  try {
    const { data } = await axios.get('/api/v1/delivery/profile', {
      withCredentials: true
    });
    if (data.success) {
      return data.deliveryStaff;
    }
  } catch (error) {
    console.error('Profile fetch error:', error);
    throw error;
  }
};

export const reassignOrderToAdmin = (orderId, reason) => async () => {
  try {
      const { data } = await axios.post(`/api/v1/delivery/order/${orderId}/reassign`,
          { reason },
          { withCredentials: true }
      );
      return data.success;
  } catch (error) {
      throw error;
  }
};


